export default build =>
    build.mutation({
        query(payload) {         
            return {
                url: '/product/markThumbnailImage',
                method: 'POST',
                body: payload,
            };
        },
        invalidatesTags: ['productbyid']       
    })
